module.exports = __webpack_public_path__ + "img/qrcode-alipay.128a7f0c.jpg";